import Vue from 'vue'
import Notifications from 'vue-notification'
import CountryFlag from 'vue-country-flag'
import Popper from 'vue-popperjs'
import VueTextareaAutosize from 'vue-textarea-autosize'
import draggable from 'vuedraggable'
import VuePrismEditor from 'vue-prism-editor'
import RadialProgressBar from 'vue-radial-progress'
import VueECharts from 'vue-echarts'

import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { faFacebookMessenger, faJsSquare } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import 'prismjs'
import 'vue-popperjs/dist/vue-popper.css'
import 'prismjs/themes/prism.css'
import 'vue-prism-editor/dist/VuePrismEditor.css'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/heatmap'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/toolbox'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/visualMap'

import Navbar from './components/Navbar'
import NavbarLink from './components/NavbarLink'
import Button from './components/Button'
import ShortCard from './components/ShortCard'
import SectionTitle from './components/SectionTitle'
import Popup from './components/Popup'
import Table from './components/Table'
import FullscreenLoader from './components/FullscreenLoader'
import LogoLoader from './components/LogoLoader'
import Gauge from './components/Gauge'
import TextEditor from './components/TextEditor'
import FullSpinner from './components/FullSpinner'

import ContextMenu from './components/context-menu/ContextMenu'
import ContextMenuOption from './components/context-menu/ContextMenuOption'

import Input from './components/form/Input'
import Select from './components/form/Select'
import MiniSelect from './components/form/MiniSelect'
import SwitchButton from './components/form/SwitchButton'
import DynamicText from './components/form/DynamicText'

import SystemInfo from './components/dashboard/SystemInfo'
import HourlyStats from './components/dashboard/HourlyStats'
import DailyStats from './components/dashboard/DailyStats'
import MonthlyStats from './components/dashboard/MonthlyStats'
import WeekActivityStats from './components/dashboard/WeekActivityStats'
import BasicStats from './components/dashboard/BasicStats'

import FlowGroup from './components/flow/FlowGroup'
import BlockEditor from './components/flow/BlockEditor'
import StepsEditor from './components/flow/StepsEditor'
import StepsCore from './components/flow/StepsCore'
import StepsRow from './components/flow/StepsRow'
import StepExponent from './components/flow/StepExponent'
import FlowElements from './components/flow/FlowElements'
import StepsSeparator from './components/flow/StepsSeparator'
import StepsValidator from './components/flow/StepsValidator'

import MessageBlock from './components/flow/blocks/Message'
import RepliesBlock from './components/flow/blocks/Replies'
import RedirectBlock from './components/flow/blocks/Redirect'
import GroupBlock from './components/flow/blocks/Group'
import DataBlock from './components/flow/blocks/Data'
import AttachmentBlock from './components/flow/blocks/Attachment'
import CarouselBlock from './components/flow/blocks/Carousel'
import CodeBlock from './components/flow/blocks/Code'
import FunctionBlock from './components/flow/blocks/Function'
import ContactBlock from './components/flow/blocks/Contact'
import RegulationsBlock from './components/flow/blocks/Regulations'
import UserDeleteBlock from './components/flow/blocks/UserDelete'
import UserInputBlock from './components/flow/blocks/UserInput'
import CommentBlock from './components/flow/blocks/Comment'
import EmailBlock from './components/flow/blocks/Email'
import MediaBlock from './components/flow/blocks/Media'
import IfBlock from './components/flow/blocks/If'
import OtnBlock from './components/flow/blocks/Otn'
import DelayedBlock from './components/flow/blocks/Delayed'
import DelayedCancelBlock from './components/flow/blocks/DelayedCancel'
import DataLoadBlock from './components/flow/blocks/DataLoad'
import SwitchBlock from './components/flow/blocks/Switch'
import RandomBlock from './components/flow/blocks/Random'
import GotoBlock from './components/flow/blocks/Goto'
import GotoLabelBlock from './components/flow/blocks/GotoLabel'
import BlockInsert from './components/flow/blocks/BlockInsert'
import HandoverBlock from './components/flow/blocks/HandoverBlock'

import MessageReply from './components/flow/blocks/elements/Reply'
import MessageButton from './components/flow/blocks/elements/Button'
import MessageGenericCard from './components/flow/blocks/elements/GenericCard'

import MainWindow from './components/livechat/MainWindow'
import LivechatList from './components/livechat/windows/UserList'
import ChatWindow from './components/livechat/windows/ChatWindow'
import UserCard from './components/livechat/elements/UserCard'
import TextMsg from './components/livechat/elements/TextMsg'
import UserGroup from './components/livechat/elements/UserGroup'
import TagsSelect from './components/livechat/elements/TagsSelect'

import AdminSettings from './components/settings/Admin'
import ChatbotSettings from './components/settings/Chatbot'
import PlatformsSettings from './components/settings/Platforms'
import PersonasSettings from './components/settings/Personas'
import StaticSettings from './components/settings/Static'
import ModKeywordsList from './components/settings/components/ModKeywordsList'

import PersonasList from './components/personas/PersonasList'
import MsgPersistent from './components/settings/MsgElements/MsgPersistent'

library.add(fas, faFacebookMessenger, faJsSquare)

Vue.use(Notifications)
Vue.use(VueTextareaAutosize)

Vue.component('prism-editor', VuePrismEditor)
Vue.component('draggable', draggable)
Vue.component('fai', FontAwesomeIcon)
Vue.component('radial-progress-bar', RadialProgressBar)
Vue.component('v-chart', VueECharts)
Vue.component('navbar', Navbar)
Vue.component('navbar-link', NavbarLink)
Vue.component('btn', Button)
Vue.component('popper', Popper)
Vue.component('country-flag', CountryFlag)

Vue.component('short-card', ShortCard)
Vue.component('section-title', SectionTitle)
Vue.component('popup', Popup)
Vue.component('tab', Table)
Vue.component('load-screen', FullscreenLoader)
Vue.component('logo-loader', LogoLoader)
Vue.component('gauge', Gauge)
Vue.component('text-editor', TextEditor)

Vue.component('context-menu', ContextMenu)
Vue.component('context-menu-option', ContextMenuOption)

Vue.component('in', Input)
Vue.component('sel', Select)
Vue.component('min-sel', MiniSelect)
Vue.component('sw-button', SwitchButton)
Vue.component('full-spinner', FullSpinner)
Vue.component('dynamic-text', DynamicText)

Vue.component('system-info', SystemInfo)
Vue.component('hourly-stats', HourlyStats)
Vue.component('daily-stats', DailyStats)
Vue.component('monthly-stats', MonthlyStats)
Vue.component('week-activity-stats', WeekActivityStats)
Vue.component('basic-stats', BasicStats)

Vue.component('flow-group', FlowGroup)
Vue.component('block-editor', BlockEditor)
Vue.component('steps-editor', StepsEditor)
Vue.component('steps-core', StepsCore)
Vue.component('steps-row', StepsRow)
Vue.component('step-exponent', StepExponent)
Vue.component('flow-elements', FlowElements)
Vue.component('steps-separator', StepsSeparator)
Vue.component('steps-validator', StepsValidator)

Vue.component('message-block', MessageBlock)
Vue.component('replies-block', RepliesBlock)
Vue.component('redirect-block', RedirectBlock)
Vue.component('group-block', GroupBlock)
Vue.component('data-block', DataBlock)
Vue.component('attachment-block', AttachmentBlock)
Vue.component('carousel-block', CarouselBlock)
Vue.component('code-block', CodeBlock)
Vue.component('function-block', FunctionBlock)
Vue.component('contact-block', ContactBlock)
Vue.component('regulations-block', RegulationsBlock)
Vue.component('user-delete-block', UserDeleteBlock)
Vue.component('user-input-block', UserInputBlock)
Vue.component('comment-block', CommentBlock)
Vue.component('email-block', EmailBlock)
Vue.component('media-block', MediaBlock)
Vue.component('if-block', IfBlock)
Vue.component('otn-block', OtnBlock)
Vue.component('delayed-block', DelayedBlock)
Vue.component('delayed-cancel-block', DelayedCancelBlock)
Vue.component('data-load-block', DataLoadBlock)
Vue.component('switch-block', SwitchBlock)
Vue.component('random-block', RandomBlock)
Vue.component('goto-block', GotoBlock)
Vue.component('goto-label-block', GotoLabelBlock)
Vue.component('block-insert-block', BlockInsert)
Vue.component('handover-block', HandoverBlock)

Vue.component('message-reply', MessageReply)
Vue.component('message-button', MessageButton)
Vue.component('message-generic-card', MessageGenericCard)

Vue.component('livechat-mw', MainWindow)
Vue.component('livechat-users', LivechatList)
Vue.component('livechat-chat', ChatWindow)
Vue.component('livechat-user-card', UserCard)
Vue.component('livechat-text-msg', TextMsg)
Vue.component('livechat-user-group', UserGroup)
Vue.component('livechat-tag-sel', TagsSelect)

Vue.component('admin-settings', AdminSettings)
Vue.component('chatbot-settings', ChatbotSettings)
Vue.component('platforms-settings', PlatformsSettings)
Vue.component('personas-settings', PersonasSettings)
Vue.component('static-settings', StaticSettings)
Vue.component('mod-keywords-list', ModKeywordsList)

Vue.component('personas-list', PersonasList)
Vue.component('msg-persistent', MsgPersistent)

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    delayMs: ms => new Promise(resolve => setTimeout(resolve, ms)),
    notify (level, key) {
      this.$notify({
        title: this.$t(`${key}.title`),
        text: this.$t(`${key}.text`),
        type: level
      })
    },
    uid: () => Math.random().toString(36).substring(2) + (new Date()).getTime().toString(36),
    formDate: (d, time) => {
      const day = (d.getDate().toString().length === 2) ? d.getDate() : '0' + d.getDate()
      const month = ((d.getMonth() + 1).toString().length === 2) ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)
      const year = d.getFullYear()
      if (!time) return day + '.' + month + '.' + year
      const hour = (d.getHours().toString().length === 2) ? d.getHours() : '0' + d.getHours()
      const minutes = (d.getMinutes().toString().length === 2) ? d.getMinutes() : '0' + d.getMinutes()
      return day + '.' + month + '.' + year + ' - ' + hour + ':' + minutes
    }
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
